/* 2026-08-16 · REVERTIDO. Se quito la LINEA DE ENVIO POR VARIANTE (#mcumbral): las
   funciones precios(), pesos() y pintaEnvio(), y su enganche al latido de 400 ms. Orden
   de Sebastian: no le gusta y prefiere la barra de progreso, que vuelve a la ficha. No
   se toco nada mas: el aviso de despacho, el stock por variante y el bus MCcarrito
   siguen exactamente igual.

   MIcase · aviso de despacho, stock por variante y bus MCcarrito.
   Extraido de snippets/micase-p-envio.liquid el 2026-08-16 para sacarlo del HTML de cada
   ficha. Sin una linea de Liquid: toda la configuracion entra por los atributos data- de
   #mcdesp y #mcstock, y los datos por variante (inventario) por el JSON de
   #mcstock-data, que sigue estando en el snippet. */

(function(){
  // Corte de despacho (12:00 en Colombia, UTC-5, sin horario de verano) y textos: se leen
  // de los atributos data- que pinta Liquid, editables desde el editor de temas. Si un
  // atributo falta o viene vacio se usa exactamente el valor de siempre.
  var CFG = null;
  function cfg(){
    if(CFG) return CFG;
    var vacio = document.createElement('div');
    var d = document.getElementById('mcdesp') || vacio;
    var s = document.getElementById('mcstock') || vacio;
    function a(n,k,f){ var v = n.getAttribute(k); return (v === null || v === '') ? f : v; }
    function num(n,k,f){ var v = parseInt(a(n,k,''), 10); return isNaN(v) ? f : v; }
    CFG = {
      corte:   num(d,'data-corte',12),
      hoy:     a(d,'data-txt-hoy','Pídelo en las próximas {tiempo} y sale hoy mismo.'),
      cerrado: a(d,'data-txt-cerrado','Los despachos de hoy ya cerraron. Si lo pides ahora, sale {dia}.'),
      manana:  a(d,'data-txt-manana','mañana'),
      lunes:   a(d,'data-txt-lunes','el lunes'),
      umbral:  num(s,'data-umbral',10),
      sing:    a(s,'data-txt-sing','Queda {n} de este modelo en este color.'),
      plur:    a(s,'data-txt-plur','Quedan {n} de este modelo en este color.'),
      uni1:    a(s,'data-uni-1','unidad'),
      unin:    a(s,'data-uni-n','unidades')
    };
    return CFG;
  }

  function bogota(){
    var d = new Date();
    return new Date(d.getTime() + d.getTimezoneOffset() * 60000 - 5 * 3600000);
  }

  function texto(){
    var c = cfg();
    var b = bogota();
    var dia = b.getDay();            // 0 domingo … 6 sabado
    var hora = b.getHours();
    var habil = dia >= 1 && dia <= 5;

    if (habil && hora < c.corte) {
      var restanMin = (c.corte - hora) * 60 - b.getMinutes();
      var h = Math.floor(restanMin / 60);
      var m = restanMin % 60;
      var falta = h > 0 ? (h + ' h ' + m + ' min') : (m + ' min');
      return c.hoy.replace('{tiempo}', '<b>' + falta + '</b>');
    }
    // Fuera del corte: se dice el proximo dia habil, sin prometer de mas.
    var proximo;
    if (dia === 5) { proximo = c.lunes; }           // viernes despues del corte
    else if (dia === 6) { proximo = c.lunes; }      // sabado
    else { proximo = c.manana; }                    // domingo y lun-jue despues del corte
    // Contador hacia el proximo corte habil, para que el reloj no se apague nunca.
    var prox = new Date(b.getTime());
    prox.setHours(c.corte, 0, 0, 0);
    if (prox <= b) { prox.setDate(prox.getDate() + 1); }
    while (prox.getDay() === 0 || prox.getDay() === 6) { prox.setDate(prox.getDate() + 1); }
    var quedan = Math.round((prox - b) / 60000);
    var qd = Math.floor(quedan / 1440);
    var qh = Math.floor((quedan % 1440) / 60);
    var qm = quedan % 60;
    var restante = qd > 0 ? (qd + ' d ' + qh + ' h') : (qh > 0 ? (qh + ' h ' + qm + ' min') : (qm + ' min'));
    return c.cerrado.replace('{dia}', '<b>' + proximo + '</b>').replace('{tiempo}', '<b>' + restante + '</b>');
  }

  function pinta(){
    var caja = document.getElementById('mcdesp');
    var el = document.getElementById('mcdesp-t');
    if(!caja || !el) return;
    el.innerHTML = texto();
    caja.hidden = false;
  }

  // --- Inventario real. Umbral por defecto definido por Sebastian: 10 o menos (editable).
  // Solo se anuncia cuando el numero es verdad y viene de Shopify; si el inventario no
  // esta gestionado, la variante ni siquiera entra en el JSON de arriba.
  var STOCK = null;

  function datos(){
    if(STOCK) return STOCK;
    var n = document.getElementById('mcstock-data');
    if(!n) return (STOCK = {});
    try { STOCK = JSON.parse(n.textContent) || {}; } catch(e){ STOCK = {}; }
    return STOCK;
  }

  function varianteActual(){
    var raiz = document.querySelector('.main-product') || document;
    var i = raiz.querySelector('[name="id"]');
    if(i && i.value) return String(i.value);
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function pintaStock(){
    var caja = document.getElementById('mcstock');
    var el = document.getElementById('mcstock-t');
    if(!caja || !el) return;
    var c = cfg();
    var id = varianteActual();
    var q = id ? datos()[id] : null;
    if(typeof q !== 'number' || q <= 0 || q > c.umbral){ caja.hidden = true; return; }
    el.innerHTML = (q === 1)
      ? c.sing.replace('{n}', '<b>1 ' + c.uni1 + '</b>')
      : c.plur.replace('{n}', '<b>' + q + ' ' + c.unin + '</b>');
    caja.hidden = false;
  }

  /* 2026-08-01 · AVISO COMUN DE "EL CARRITO CAMBIO".
     El boton principal de compra es del tema (assets/main-product.js) y agrega por AJAX
     sin avisarle a nuestras secciones, asi que los indicadores de envio gratis se
     quedaban con el subtotal de antes. Este ayudante escucha por dos vias y avisa una
     sola vez, con el carrito ya leido:
       1) el bus del propio tema (subscribe / PUB_SUB_EVENTS.cartUpdate de assets/utils.js);
       2) como respaldo, el contador .cart-count de la cabecera y el bloque #minicart-form,
          que el tema reescribe SIEMPRE que el carrito cambia, venga el cambio de donde
          venga. Con MutationObserver, sin setInterval.
     Se define una sola vez aunque el fragmento este repetido en varios archivos. */
  window.MCcarrito = window.MCcarrito || (function(){
    var subs=[], t=null, listo=false;
    function reparte(c){ for(var i=0;i<subs.length;i++){ try{ subs[i](c) }catch(e){ console.warn('[MIcase] micase-p-envio: fallo un suscriptor de MCcarrito al recibir el carrito', e); } } }
    function lee(){
      fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
        .then(function(r){ if(!r.ok) throw 0; return r.json() })
        .then(reparte)
        .catch(function(){ reparte(null) });
    }
    function avisa(){ clearTimeout(t); t=setTimeout(lee,300); }
    function mira(n,cfg){ if(n){ try{ new MutationObserver(avisa).observe(n,cfg) }catch(e){ console.warn('[MIcase] micase-p-envio: no se pudo observar el nodo del carrito con MutationObserver', e); } } }
    function arranca(){
      if(listo) return; listo=true;
      try{
        if(typeof subscribe==='function' && typeof PUB_SUB_EVENTS!=='undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate){
          subscribe(PUB_SUB_EVENTS.cartUpdate, avisa);
        }
      }catch(e){ console.warn('[MIcase] micase-p-envio: no se pudo suscribir al evento cartUpdate del tema', e); }
      if(typeof MutationObserver!=='function') return;
      var cc=document.querySelectorAll('.cart-count');
      for(var i=0;i<cc.length;i++){ mira(cc[i].parentNode||cc[i],{childList:true,characterData:true,subtree:true}) }
      mira(document.getElementById('minicart-form'),{childList:true});
      // Volver atras con el carrito ya cambiado (bfcache) tampoco puede dejar cifras viejas.
      window.addEventListener('pageshow',function(e){ if(e.persisted) avisa() });
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',arranca);
    else arranca();
    return { on:function(f){ if(typeof f==='function') subs.push(f) }, avisa:avisa };
  })();
  function init(){
    pinta();
    pintaStock();
    setInterval(pinta, 60000);

    // 2026-08-01 · LA BARRA TAMBIEN SE ACTUALIZA CON EL BOTON DE COMPRA DEL TEMA.
    // El tema refresca UNA sola <free-ship-progress-bar>, la primera del documento
    // (document.querySelector en main-product.js y cart-components.js), que es la del
    // minicarrito: la de esta ficha se quedaba con el subtotal del primer render.
    // Cuando MCcarrito avisa se repintan TODAS con el subtotal recien leido.
    // 2026-08-10 · el repintado real lo hace window.MCfePinta (definido en el snippet
    // micase-envio-barra, que ya se suscribe solo a MCcarrito). Aqui no queda nada que
    // hacer: la llamada vieja a b[i].init() era un no-op (custom element de Glozin que
    // Dawn nunca define).

    // El cambio de variante no llega de forma fiable ni por `change` ni por mutaciones de
    // atributo: el tema marca los radios por propiedad, no por atributo, y el evento no
    // siempre burbujea hasta document (verificado: al cambiar de modelo el recuadro seguia
    // mostrando el stock de la variante anterior). Se vigila directamente el id de variante,
    // que es el dato que de verdad manda, con un intervalo corto.
    var ultimoId = null;
    setInterval(function(){
      var id = varianteActual();
      if(id !== ultimoId){ ultimoId = id; pintaStock(); }
    }, 400);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();